<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <p>
          Thanks for signing up! You'll be receiving an email with more details momentarily.
        </p>

        <div class="pure-u-sm-1-5"></div>
        <img class="pure-u-1 pure-u-sm-3-5" src="../../assets/images/ipas.jpg">
        <p>
          Look forward to 8 handpicked, well rated IPAs every month.
        </p>
        <p>
          We want to keep the beers as fresh as possible.
          That's why we ship out just once a month (around the 15th).
          We're ecstatic to get great IPAs to you.
        </p>
        <p>
          If you have any questions, comments, suggestions you can email
          us anytime at <a href="mailto:support@tavour.com">support@tavour.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'SuccessHopBomb',
    created() {
      /* global ga fbq */
      ga('send', 'pageview', `/${store.get('subscription')}/Success`);
      fbq('track', 'IPASubsConfirm');

      store.clear();
    },
  };
</script>

<style>
  img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// SuccessHopBomb.vue?7a90a2dc